import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classNames from 'classnames';
import Waypoint from 'react-waypoint';

import EBPropTypes from 'js-utils/prop-types';

import { BUCKET_CONFIG_PROPTYPE } from '../constants/propTypes';

import OrganizersCards from './OrganizersCards';

import './OrganizersBucket.scss';

class OrganizersBucket extends Component {
    static propTypes = {
        handleFollowOrganizer: PropTypes.func.isRequired,
        handlePopOrganizer: PropTypes.func,
        handleAddOrganizers: PropTypes.func,
        handleViewOrganizer: PropTypes.func,
        trackGAEvent: PropTypes.func,
        bucketKey: PropTypes.string,
        bucketConfig: BUCKET_CONFIG_PROPTYPE,
        bucketContent: PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string,
        }),
        areProfilesLoading: PropTypes.bool,
        isMobile: PropTypes.bool,
        name: EBPropTypes.translation,
        profiles: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
                image: PropTypes.shape({
                    url: PropTypes.string,
                }),
            }),
        ),
        shouldUseWaypoints: PropTypes.bool,
    };

    static defaultProps = {
        profiles: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            visible: !props.shouldUseWaypoints,
        };
    }

    componentDidMount() {
        this.props.handleAddOrganizers();
    }

    _handleWaypointEnter = () => {
        this.setState({ visible: true });
    };

    render() {
        const {
            // eslint-disable-next-line no-shadow
            name,
            bucketContent: { description },
            bucketConfig,
            profiles,
            bucketKey,
            areProfilesLoading,
            handlePopOrganizer,
            handleFollowOrganizer,
            handleViewOrganizer,
            trackGAEvent,
        } = this.props;
        const { visible } = this.state;
        const desktopLayoutConfig = get(
            bucketConfig,
            'layout.desktop.events',
            {},
        );

        let titleComponent = null;

        if (name) {
            const titleClassNames = classNames(
                'eds-text-color--grey-900',
                'eds-text-hs',
                'eds-l-pad-bot-2',
            );

            titleComponent = <span className={titleClassNames}>{name}</span>;
        }

        let descriptionComponent = null;

        if (description) {
            const descriptionClassNames = classNames(
                'eds-text-color--grey-600',
                'eds-text-bm',
            );

            descriptionComponent = (
                <span className={descriptionClassNames}>{description}</span>
            );
        }

        const bucketClassNamesDesktop = classNames(
            'feed-events-bucket',
            'feed-events-bucket--animated',
            {
                animate: visible,
            },
        );

        const bucketHeaderClassNames = classNames(
            'eds-l-pad-bot-6',
            'eds-l-sm-pad-bot-10 eds-l-sw-pad-bot-8 pad-bot-mn-up',
            'eds-l-mn-pad-hor-3',
            'eds-l-md-pad-hor-3',
            'eds-l-mw-pad-hor-3',
            'eds-l-ln-pad-hor-3',
            'eds-l-lg-pad-hor-3',
            'eds-l-lw-pad-hor-3',
        );
        const bucketHeader = (
            <div className={bucketHeaderClassNames}>
                {titleComponent}
                <div className="eds-g-group">
                    <div className="eds-g-cell eds-g-cell-mn-6-12">
                        {descriptionComponent}
                    </div>
                </div>
            </div>
        );

        return (
            <Waypoint onEnter={this._handleWaypointEnter} topOffset="-1000px">
                <div className={bucketClassNamesDesktop}>
                    {bucketHeader}

                    <OrganizersCards
                        bucketKey={bucketKey}
                        isLoading={areProfilesLoading}
                        handleFollowOrganizer={handleFollowOrganizer}
                        handlePopOrganizer={handlePopOrganizer}
                        handleViewOrganizer={handleViewOrganizer}
                        trackGAEvent={trackGAEvent}
                        visible={visible}
                        profiles={profiles}
                        bucketLayoutConfig={desktopLayoutConfig}
                    />
                </div>
            </Waypoint>
        );
    }
}

export default OrganizersBucket;
